import { cn } from "../../lib";

interface IStatusChipProps {
  label: string;
  className: string;
}

const StatusChip: React.FC<IStatusChipProps> = ({ label, className }) => (
  <span
    className={cn(
      "inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap",
      className,
    )}
  >
    {label}
  </span>
);

export default StatusChip;
